export const MAIN_COLOR = "#1ba622";
